module.exports = __webpack_public_path__ + "static/img/lemon-m.c5dc211.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/lemon-m.jpg
// module id = MwnU
// module chunks = 0